<template>
	<div>

		<widget title="Taxes">

			<button class="btn btn-success" v-on:click="newItem">
				<i class="fa fa-plus"></i>
				Add Tax
			</button>
			
			<table-list
				class="card-body"
				style="margin-top: 0;"
				record-name="Tax Item"
				:fields="fields"
				id-field="name"
				:records="taxes"
				:sortable="true"
				:has-delete="true"
				hide-record-count="true"
				:other-buttons='[
					{
						text: "Disable Default",
						icon:"fa-check-square",
						click: "disableDefault",
						class: "btn-light",
						condition: ["isDefault",1]
					},
					{
						text: "Apply by Default",
						icon:"fa-square",
						click: "applyDefault",
						class: "btn-light",
						condition: ["isDefault",0]
					},
				]'
				v-on:delete="deleteItem"
				v-on:applyDefault="applyDefault($event,1)"
				v-on:disableDefault="applyDefault($event,0)"
				v-on:closeModal="editModal.visible = false">
			</table-list>
		</widget>

		<modal-dialog
			:modal-visible="editModal.visible"
			:title="editModal.title"
			confirm-button-text="Save"
			v-on:confirm="saveItem"
			v-on:closeModal="editModal.visible = false">

			<field label="Tax Name" 
				col-class="col-md-4"
				v-model="editModal.payload.name">
			</field>

			<field label="Percentage %" 
				col-class="col-md-4"
				:params="{type:'number',min:0,max:100,step:0.1}"
				v-model="editModal.payload.percentage">
			</field>

		</modal-dialog>

	</div>
</template>

<script>
import ModalDialog from "@/components/ModalDialog"
import TableList from "@/components/TableList"
import Field from "@/components/Field"
import Widget from "@/components/Widget"

export default {

	name: 'TaxSettings',
	components: {
		ModalDialog,
		TableList,
		Field,
		Widget
	},
	data() {
		return {
			taxes: [],
			editModal: {
				visible: false,
				title: "Add Tax Item",
				payload: {}
			},
			fields: [
				{label: "Tax Name",key:"name"},
				{label: "Apply by Default",key:"isDefault",type:'boolean'},
				{label: "Percentage %",key:"percentage"}
			]
		}
	},
	methods: {
		deleteItem(item) {
			let vm = this

			//find item in array
			this.taxes = this.taxes.filter(tax => {
				if (tax.name == item.name)
					return false
				else
					return true
			})

			this.saveTaxes()
		},
		saveTaxes(isSave) {
			let vm = this

			//convert array of taxes into object
			let taxes = {}

			this.taxes.forEach(tax => {

				let percentage = tax.percentage/100

				percentage = percentage.toFixed(3)

				taxes[tax.name] = percentage
			})

			let payload = {
				taxes_json: JSON.stringify(taxes)
			}

			this.postData("CompanySetting/save",payload,true).then(response => {
				if (response.success) {

					if (isSave)
						vm.alertSaved("Tax saved")
					else
						vm.alertSuccess("Tax deleted")

					vm.fetchData()

					vm.editModal.visible = false
				}
			})
		},
		applyDefault(record,apply) {
			let vm = this

			console.log(record,this.taxes)

			let applyValue = apply ? 1 : 0

			let taxes = {}

			this.taxes.forEach(tax => {
				if (tax.name == record.name) {
					taxes[tax.name] = {
						taxRate: +tax.percentage / 100,
						isDefault: applyValue
					}
				}
				else {
					taxes[tax.name] = {
						taxRate: +tax.percentage / 100,
						isDefault: tax.isDefault
					}
				}
			})

			let payload = {
				taxes_json: JSON.stringify(taxes)
			}

			
			this.postData("CompanySetting/save",payload,true).then(response => {
				if (response.success) {
					vm.fetchData()
				}
			})
			
		},
		newItem() {
			this.editModal.visible = true
			this.editModal.payload = {}
		},
		saveItem() {
			let vm = this

			this.taxes.push({
				name: this.editModal.payload.name,
				percentage: this.editModal.payload.percentage
			})

			this.saveTaxes(true)			
		},

		setTaxes() {
			let vm = this

			try {
				let taxes = JSON.parse(this.$store.company.CompanySetting.taxes_json)

				vm.taxes = []
				//convert to array
				Object.keys(taxes).forEach((key, index) => {

					let value = taxes[key], percentage, isDefault = 0

					//handle whether value is an object, or just a straight tax rate
					if (typeof value == 'object') {
						percentage = +value.taxRate * 100
						isDefault = value.isDefault
					}
					else
						percentage = +value * 100

					percentage = percentage.toFixed(1)

					let tax = {
						name: key,
						percentage,
						isDefault
					}

					vm.taxes.push(tax)
				})
			}
			catch (ex) {
				console.log(ex)
			}
		},
		fetchData() {
			let vm = this

			this.fetchCompanyData(true,["CompanySetting"]).then(response => {
				vm.setTaxes()
			})
		},
		getTaxes() {
			let vm = this

			if (!("CompanySetting" in this.$store.company)) {
				this.fetchData()
			}
			else
				vm.setTaxes()
		}
	},
	created() {
		this.getTaxes()
		this.fetchData()
	}

}
</script>